import { request, success, failure, USER_REQUEST, TODO } from "./utilities";
import {
  loginUser,
  getUserListing,
  getUserSelectListByRoleApi,
  loginCovisTourApi,
} from "../api";
import { GetRequest, PostRequest } from "../api/genericApiCalls";
import { APP_SETTINGS } from "../../config";

export function login(loginData, setCookiesforUser, Notification) {
  return (dispatch) => {
    dispatch(request(USER_REQUEST.USER_SIGNIN_REQUEST));
    loginUser(loginData).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(USER_REQUEST.USER_SIGNIN_SUCCESS, response.data.data)
          );
          setCookiesforUser(response.data.data, loginData);
        } else {
          dispatch(
            failure(USER_REQUEST.USER_SIGNIN_FAILURE, response.data.message)
          );
          if (Notification) {
            Notification(response.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(failure(USER_REQUEST.USER_SIGNIN_FAILURE, error.message));
      }
    );
  };
}
export function loginCovisTourAction(loginData, onSuccess) {
  return (dispatch) => {
    dispatch(request(USER_REQUEST.LOGIN_COVIS_TOUR_REQUEST));
    loginCovisTourApi(loginData).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(USER_REQUEST.LOGIN_COVIS_TOUR_SUCCESS, response.data.data)
          );
          if (onSuccess) {
            onSuccess();
          }
        } else {
          dispatch(
            failure(
              USER_REQUEST.LOGIN_COVIS_TOUR_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(failure(USER_REQUEST.LOGIN_COVIS_TOUR_FAILURE, error.message));
      }
    );
  };
}

export function getUsersList(token) {
  return (dispatch) => {
    dispatch(request(USER_REQUEST.GET_USERS_LISTING_REQUEST));
    getUserListing(token).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(USER_REQUEST.GET_USERS_LISTING_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(
              USER_REQUEST.GET_USERS_LISTING_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            USER_REQUEST.GET_USERS_LISTING_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.message
              ? error.response.data.message
              : error.message
          )
        );
      }
    );
  };
}

export function getTeamMembers(userData, token) {
  return (dispatch) => {
    dispatch(request(USER_REQUEST.GET_TEAM_MEMBERS_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.USERS.getTeamMembers}?teamLeadId=${userData.teamLeadId}`;
    PostRequest(path, null, token).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(USER_REQUEST.GET_TEAM_MEMBERS_SUCCES, response.data.data)
          );
        } else {
          dispatch(
            failure(
              USER_REQUEST.GET_TEAM_MEMBERS_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            USER_REQUEST.GET_TEAM_MEMBERS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.message
              ? error.response.data.message
              : error.message
          )
        );
      }
    );
  };
}

export function getTeamLeadsData() {
  return (dispatch) => {
    dispatch(request(USER_REQUEST.GET_TEAMLEADS_REQUEST));
    GetRequest(APP_SETTINGS.API_PATH.USERS.getTeamLeads, null).then(
      (resp) => {
        if (resp.data.status === 1) {
          dispatch(success(USER_REQUEST.GET_TEAMLEADS_SUCCESS, resp.data.data));
        } else {
          dispatch(failure(USER_REQUEST.GET_TEAMLEADS_FAILURE, resp.data));
        }
      },
      (error) => {
        dispatch(failure(USER_REQUEST.GET_TEAMLEADS_FAILURE, error.message));
      }
    );
  };
}

export function getEmployeeData(info, orgId, token) {
  // console.log('token get', token);
  return (dispatch) => {
    dispatch(request(USER_REQUEST.GET_EMPLOYEES_SELECTLIST_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.USERS.getEmployeesSelectList}?organziationId=${orgId}`;
    PostRequest(path, null, token).then(
      (resp) => {
        // console.log('emp resp', resp);
        if (resp.data.status === 1) {
          dispatch(
            success(
              USER_REQUEST.GET_EMPLOYEES_SELECTLIST_SUCCESS,
              resp.data.data,
              info
            )
          );
        } else {
          dispatch(
            failure(USER_REQUEST.GET_EMPLOYEES_SELECTLIST_FAILURE, resp.data)
          );
        }
      },
      (error) => {
        dispatch(
          failure(USER_REQUEST.GET_EMPLOYEES_SELECTLIST_FAILURE, error.message)
        );
      }
    );
  };
}

export function GetEmployeesList(token) {
  return (dispatch) => {
    dispatch(request(USER_REQUEST.GET_EMPLOYEES_LIST_REQUEST));
    var path = APP_SETTINGS.API_PATH.USERS.getEmployeesList;
    GetRequest(path, token).then(
      (response) => {
        if (response.data) {
          dispatch(
            success(USER_REQUEST.GET_EMPLOYEES_LIST_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(
              USER_REQUEST.GET_EMPLOYEES_LIST_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        // console.log('error.message', error.message);
        dispatch(
          failure(
            USER_REQUEST.GET_EMPLOYEES_LIST_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function UpdateEmpDepartment(reqData, token, close) {
  return (dispatch) => {
    dispatch(request(USER_REQUEST.UPDATE_DEPARTMENT_REQUEST));
    var path = APP_SETTINGS.API_PATH.USERS.updateUserDepartment;
    PostRequest(path, reqData, token).then(
      (response) => {
        if (response.data) {
          dispatch(
            success(USER_REQUEST.UPDATE_DEPARTMENT_SUCCESS, response.data.data)
          );
          if (close) {
            close();
          }
        } else {
          dispatch(
            failure(
              USER_REQUEST.UPDATE_DEPARTMENT_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        // console.log('error.message', error.message);
        dispatch(
          failure(
            USER_REQUEST.UPDATE_DEPARTMENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getUserSelectListByRole(auth) {
  return (dispatch) => {
    dispatch(request(USER_REQUEST.GET_EMPLOYEES_SELECT_LIST_BY_ROLE_REQUEST));
    getUserSelectListByRoleApi(auth).then(
      (response) => {
        // console.log('teamMembers  resp', response);
        if (response.data.status === 1) {
          dispatch(
            success(
              USER_REQUEST.GET_EMPLOYEES_SELECT_LIST_BY_ROLE_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              USER_REQUEST.GET_EMPLOYEES_SELECT_LIST_BY_ROLE_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            USER_REQUEST.GET_EMPLOYEES_SELECT_LIST_BY_ROLE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.message
              ? error.response.data.message
              : error.message
          )
        );
      }
    );
  };
}
